import React from "react";
import "../RegAdmission/RegAdmission.css";
import { RegAdmissionData } from "../../Data/Data";
import { FaCheckCircle } from "react-icons/fa";

const RegAdmission = () => {
  return (
    <section className="regadmission-section">
      <div className="container">

        {/* HEADER */}
        <div className="reg-header text-center">
          <h2 className="reg-title">
            {/* <span>Registration</span> & Admission */}
            <span>REGISTRATION & ADMISSION</span>
          </h2>

          <p className="reg-subtitle">
            A complete guide to admission process, policies, fees and student journey
          </p>

          {/* <div className="title-line"></div> */}
        </div>

        {/* CARDS */}
        <div className="row g-4 mt-4">
          {RegAdmissionData.map((item, index) => (
            <div className="col-12 col-md-6" key={index}>
              <div className="reg-card">

                <div className="card-border"></div>

                <h4 className="reg-card-title">{item.title}</h4>

                <ul className="reg-list">
                  {item.content.map((point, i) => (
                    <li key={i}>
                      <FaCheckCircle className="icon" />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>

              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-5">
          {/* <button className="apply-btn">
            Apply for Admission
          </button> */}
          <a href="/onlineregister"><button className="apply-btn"> Apply for Admission</button></a>
        </div>

      </div>
    </section>
  );
};

export default RegAdmission;